var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiselectDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160511",
    "data-name": "Group 160511",
    transform: "translate(-376 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    "data-name": "Rectangle 1910",
    width: 16,
    height: 16,
    transform: "translate(376 104)",
    fill: "rgba(255,229,229,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(376.73 105.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M3,6h8.54",
    transform: "translate(0 -2.052)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M11.637,3.708V9.686a.9.9,0,0,1-.948.854H5.948A.9.9,0,0,1,5,9.686V3.708m1.422,0V2.854A.9.9,0,0,1,7.37,2h1.9a.9.9,0,0,1,.948.854v.854",
    transform: "translate(-1.048 0.222)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y2: 3.111,
    transform: "translate(6.236 5.738)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y2: 3.111,
    transform: "translate(8.304 5.738)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectDeleteIcon);
export default __webpack_public_path__ + "static/media/MultiselectDelete-icon.dfa383eef22ca7ca7f3ffe9b2bc5c6e2.svg";
export { ForwardRef as ReactComponent };